import React from "react";
import HeaderContainer from "../Header/HeaderContainer";

import { Affix, Col, Grid, Layout, Row, Space, Typography } from "antd";
import transferenceIcon from "assets/namespace/icons/tfrIcon";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import Icon from "@ant-design/icons";
import BackBtn from "components/reusables/BackBtn/BackBtnComponent";
import NextStepBtnComponent from "components/reusables/NextStepBtn/NextStepBtnComponent";
import AccordionNavComponent from "components/reusables/AccordionNav/AccordionNavComponent";
import { AccordionNavComponentTypes } from "components/reusables/AccordionNav/AccordionNavComponent.types";
import StepFlowComponent from "components/reusables/StepFlow/StepFlowComponent";
import MinimalFooterComponent from "components/reusables/MinimalFooter/MinimalFooterComponent";
import ButtonsNavComponent from "components/reusables/ButtonsNav/ButtonsNavComponent";
import InfoCarousel from "components/reusables/InfoCarousel/InfoCarouselComponent";
import NextBackBtnComponent from "components/reusables/NextBackBtn/NextBackBtnComponent";
import { IButtonsNavTypes } from "components/reusables/ButtonsNav/ButtonsNav.types";
const { Title } = Typography;
const { useBreakpoint } = Grid;

/* Accordion Content images */
//first accordion vehicleInfo
import generalInfo1 from "../../../assets/namespace/img/1_info_general.png";
import generalInfo2 from "../../../assets/namespace/img/2_info_general.png";
import infoPdc3 from "../../../assets/namespace/img/3_info_pdc.png";
import infoPago4 from "../../../assets/namespace/img/4_info_pago.png";

//accordion businesInfo
import buyerInfo1 from "../../../assets/namespace/img/5_comprador_1.png";
import buyerInfo2 from "../../../assets/namespace/img/5_comprador_2.png";
import sellerInfo1 from "../../../assets/namespace/img/6_vendedor_1.png";
import sellerInfo2 from "../../../assets/namespace/img/6_vendedor_2.png";

import vehicleInfo from "../../../assets/namespace/img/vehicle_info.png";
import businessInfo from "../../../assets/namespace/img/business_info.png";
import businessDocuments from "../../../assets/namespace/img/business_documents.png";

//accordion docsInfoContent
import thanks from "../../../assets/namespace/img/7_gracias.png";
import TextHeaderComponent from "components/reusables/TexlHeader/TextHeaderComponent";

/* end content images */
const TfrIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={transferenceIcon} {...props} />
);
const { Header, Sider, Content, Footer } = Layout;

const vehicleInfoContent = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
    <div className="contentLabel">
      Para realizar la transferencia es requisito tener información detallada
      del vehículo y que éste no presente limitaciones al dominio, además se
      debe tener el documento del último permiso de circulación, entre otros.
    </div>
    <InfoCarousel items={[generalInfo1, generalInfo2, infoPdc3, infoPago4]} />
  </div>
);

const businessInfoContent = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
    <div className="contentLabel">
      La información a ingresar debe ser fidedigna ya que si no se ingresan bien
      los datos habrá error en el proceso y tomará más tiempo.
    </div>
    <InfoCarousel items={[buyerInfo1, buyerInfo2, sellerInfo1, sellerInfo2]} />
  </div>
);
const docsInfoContent = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
    <div className="contentLabel">
      Luego de completar toda la información solicitada, Autofact genera los
      documentos oficiales en un tiempo de 3 horas, pero si existe algún error
      en la información proporcionada, pasa a revisión manual.
    </div>
    <InfoCarousel items={[thanks]} />
  </div>
);

const TabsInfo: IButtonsNavTypes = {
  TabsContent: [
    {
      title: 'Información del vehículo',
      slug: 'vehicle-info',
      text: "Para realizar la transferencia es requisito tener información detallada del vehículo y que éste no presente limitaciones al dominio, además se debe tener el documento del último permiso de circulación, entre otros.",
      contentImg: vehicleInfo

    },
    {
      title: 'Información del comprador y vendedor',
      slug: 'business-info',
      text: "La información a ingresar debe ser fidedigna ya que si no se ingresan bien los datos habrá error en el proceso y tomará más tiempo.",
      contentImg: businessInfo,
    },
    {
      title: 'Documentos compraventa',
      slug: 'business-docs',
      text: "Luego de completar toda la información solicitada, Autofact genera los documentos oficiales en un tiempo de 3 horas, pero si existe algún error en la información proporcionada, pasa a revisión manual.",
      contentImg: businessDocuments,
    }
  ],
};
const AvailableInfo: AccordionNavComponentTypes = {
  AvailableContent: [
    {
      title: "Información del vehículo",
      slug: "vehicle-info",
      content: vehicleInfoContent(),
    },
    {
      title: "Información del comprador y vendedor",
      slug: "business-info",
      content: businessInfoContent(),
    },
    {
      title: "Documentos compraventa",
      slug: "docs-info",
      content: docsInfoContent(),
    },
  ],
};

function ContractFormContainer() {
  const screens = useBreakpoint();
  return (
    <div id="container">
      <div><Layout id="body">
        <Space direction="vertical" size={35}>
          <HeaderContainer />
          <Layout
            style={{
              padding: "1rem",
              alignItems: "center",
              maxWidth: "1140px",
              margin: "auto",
            }}
          >
            <TextHeaderComponent />
            <StepFlowComponent className={""}></StepFlowComponent>
            <Row style={{ justifyContent: "center" }}>
              <Col xs={24} md={20} style={{ maxWidth: "1024px" }}>
                <Space size={24} direction="vertical">
                  <div>
                    {/* TODO: move to component */}
                    <Row style={{ paddingTop: `${!screens["lg"] ? '5px' : '20px'}`, justifyContent: 'center' }}>
                      <Col style={{ maxWidth: '630px' }}>
                        <Space size={16} direction="vertical">
                          <Col span={24}>
                            <Title
                              className={"body-text-header"}
                              style={{ textAlign: "center" }}
                            >
                              Formulario de contrato y documentos compraventa
                            </Title>
                          </Col>
                          <Row>
                            <div>
                              <p
                                className={"vehicle-buy-text-description"}
                              >
                                {
                                  <>
                                    {
                                      <span style={{ fontWeight: "700" }}>
                                        {" "}
                                        Este es el primer paso luego del pago
                                        inicial de honorarios Autofact y
                                        notario.
                                      </span>
                                    }
                                    <br />
                                    No es necesario que rellenes los campos del formulario que exponemos acá,
                                    solo en el proceso real debes asegurarte de completar correctamente la
                                    información solicitada.{" "}
                                    <br />
                                    <br />
                                    {
                                      <span style={{ fontWeight: "700", display: screens.md ? 'inline-block' : 'none' }} >
                                        {" "}
                                        Recuerda, aquí exponemos el proceso de
                                        Transferencia a modo de ejemplo.
                                      </span>
                                    }
                                  </>
                                }
                              </p>
                            </div>
                          </Row>
                        </Space>
                      </Col>
                    </Row>
                    {/* end move to component */}
                  </div>
                  <div style={{ alignItems: "center" }}>
                    {!screens["lg"] ? (
                      <AccordionNavComponent
                        AvailableContent={AvailableInfo.AvailableContent}
                      />
                    ) : (
                      <ButtonsNavComponent
                        TabsContent={TabsInfo.TabsContent}
                      />
                    )}
                  </div>
                </Space>
                <Row style={{ justifyContent: "end" }}>
                  <Col md={12} xs={0}>
                    <NextBackBtnComponent
                      id='simTrf-step2-tag'
                      value={`/opciones/contrato-servicio-tag/`}
                      rowClassName="rowClassName"
                    ></NextBackBtnComponent>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Layout>
        </Space>
      </Layout>
        <Affix offsetBottom={1}>
          {/* <NextBackBtnComponent id="fix-mobile-footer" className="mobileStyle"></NextBackBtnComponent> */}
          <div
            id="fix-mobile-footer"
            className="mobileStyle"
          // style={{
          //   backgroundColor: "#ffff",
          //   boxShadow: "4px 0px 10px rgba(143, 171, 195, 0.3)",
          // }}
          >
            <Row justify="center" align="middle" style={{ padding: "1rem" }}>
              <Col style={{ width: "50%" }}>
                <BackBtn label={"Volver"} title="Volver atrás"></BackBtn>
              </Col>
              <Col style={{ width: "50%" }}>
                <NextStepBtnComponent
                  id='simTrf-step2-tag'
                  value={`/opciones/contrato-servicio-tag/`}
                  text={"Siguiente"}
                  action={() => {
                    alert("Clicked");
                  }}
                />
              </Col>
            </Row>
          </div>
        </Affix>

      </div>

      <div id="footer">
        <MinimalFooterComponent />
      </div>
    </div>
  );
}

export default ContractFormContainer;
